<template>
    <div class="bg-0A1129 text-white min-vh-100">
        <Mainlayout />
        <div class="container-fluid pt-5">
            <br /><br /><br />
            <div class="text-right">
                <CButton class="mb-2 text-white mr-3" @click="SignOut()">Logout</CButton>
            </div>
            <div class="row p-3">
                <div class="col-md-12">
                    <CCard class="custom-card-101C46">
                        <h2 class="mb-4">1. BUTIRAN PEMBELIAN</h2>
                        <div v-if="cartItems.length > 0" class="w-100">
                            <div v-for="(groupItems, groupTitle) in groupedFlattenedCart" :key="groupTitle" class="mb-4">
                                <!-- Group Title -->
                                <h5 class="text-white mb-2">{{ groupTitle }}</h5>
    
                                <!-- Items under group -->
                                <!-- Items under group -->
                                <div v-for="(item, index) in groupItems" :key="index" class="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3 p-2 border rounded bg-dark text-white">
                                    <!-- Checkbox -->
                                    <div class="form-check mr-md-3 mb-2 mb-md-0">
                                        <input type="checkbox" class="form-check-input" :id="'select-' + item.SubjectUID" :value="item.SubjectUID" v-model="selectedItems" :disabled="item.Status !== true && item.Status !== 'true'" />
                                    </div>
    
                                    <!-- Image -->
                                    <div class="mr-md-3 mb-2 mb-md-0 text-center">
                                        <img :src="item.PicturePath" width="70" class="rounded" />
                                    </div>
    
                                    <!-- Title & Subject Info -->
                                    <div class="flex-grow-1 mb-2 mb-md-0">
                                        <div :class="{ 'text-muted': !item.Status, 'text-white': item.Status }">
                                            <small v-if="item.SubjectDetails">
                                            {{ item.SubjectDetails.CourseName }}<br />
                                            {{ item.SubjectDetails.Date | moment('DD/MM/YYYY') }} |
                                            {{ item.SubjectDetails.Time | moment('HH:mm') }}
                                          </small>
                                            <div v-if="!item.Status" class="text-warning mt-1">
                                                <small>Not Available</small>
                                            </div>
                                        </div>
                                       <!-- Choose Student Button -->
                                        <button class="btn btn-sm bg-1796FD text-white mr-2" @click="OpenStudent(item)" style="width:120px">
                                          Sila Pilih Pelajar
                                        </button>

                                        <!-- Show selected student -->
                                        <div v-if="selectedStudentsMap[item.SubjectUID]" class="mt-1 text-white">
                                          You buy this package for: <strong>{{ selectedStudentsMap[item.SubjectUID].name }}</strong>
                                        </div>
                                     </div>
    
                                    <!-- Price + Controls -->
                                    <div class="ml-md-3 text-left text-md-right w-100 w-md-auto">
                                        <div>
                                            <strong :class="{ 'text-muted': !item.Status, 'text-white': item.Status }">
                                            RM {{ (item.Price - item.Discount) * (item.Quantity || 1) }}
                                          </strong>
                                        </div>
    
                                        <!-- Quantity Controls -->
                                        <div class="d-flex align-items-center justify-content-start justify-content-md-end mt-2">
                                            <button class="btn btn-sm btn-secondary mr-2" @click="decreaseQty(item)">−</button>
                                            <span class="mx-2">{{ item.Quantity || 1 }}</span>
                                            <button class="btn btn-sm btn-secondary ml-2" @click="increaseQty(item)">+</button>
                                        </div>
    
                                        <!-- Remove Button -->
                                        <div class="mt-2 text-left text-md-right">
                                            <button class="btn btn-sm btn-danger" @click="removeItem(item.SubjectUID)">X</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <h4 class="text-right">Jumlah Dipilih: <strong>RM {{ selectedTotal }}</strong></h4>
                        </div>
                        <div v-else>
                            <p>Tiada item dalam troli.</p>
                        </div>
                    </CCard>
                    <!-- The rest remains unchanged -->
                    <CCard class="custom-card-101C46">
                        <CRow class="w-100 justify-content-between align-items-center">
                            <div class="d-inline-block px-4 py-2 border border-success text-white rounded-pill" style="background-color: #0A1129;">
                                Perhatian! Sila lengkapkan borang di bawah.
                            </div>
    
                            <div class="d-inline-block px-4 py-2 border border-danger text-white rounded-pill" style="background-color: #0A1129;">
                                *Ruangan yang wajib diisi
                            </div>
                        </CRow>
    
                        <h2 class="mb-4">2. BUTIRAN PELANGGAN</h2>
                        <div class="w-100">
                            <h4 class="custom-20px-400">Name*</h4>
                            <div style="position: relative; display: inline-block; width: 100%;">
                                <img src="../assets/img/flyhigh/user.png" alt="User Icon" style="
                                                                position: absolute;
                                                                left: 12px;
                                                                top: 50%;
                                                                transform: translateY(-50%);
                                                                width: 20px;
                                                                height: 20px;
                                                                pointer-events: none;
                                                                " />
                                <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter  Name" v-model="FullName" disabled/>
                            </div>
                            <h4 class="custom-18px-400 text-white text-left mt-3">Email</h4>
                            <div style="position: relative; display: inline-block; width: 100%;">
                                <img src="../assets/img/flyhigh/sms.png" alt="User Icon" style="
                                                                                                position: absolute;
                                                                                                left: 12px;
                                                                                                top: 50%;
                                                                                                transform: translateY(-50%);
                                                                                                width: 20px;
                                                                                                height: 20px;
                                                                                                pointer-events: none;
                                                                                                " />
                                <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter your Email" v-model="email" disabled/>
                            </div>
    
    
                            <h4 class="custom-18px-400 text-white text-left mt-3">Phone Number</h4>
                            <div style="position: relative; display: inline-block; width: 100%;">
                                <img src="../assets/img/flyhigh/phone.png" alt="User Icon" style="
                                                                                                position: absolute;
                                                                                                left: 12px;
                                                                                                top: 50%;
                                                                                                transform: translateY(-50%);
                                                                                                width: 20px;
                                                                                                height: 20px;
                                                                                                pointer-events: none;
                                                                                            
                                                                                                " />
                                <input type="text" class="custom-bg-blue-black pl-5" style="border-radius: 16px; width: 100%; padding-left: 40px; font-size: 16px;color: white;padding:16px" placeholder="Enter your Phone Number" v-model="phone" disabled/>
                            </div>
    
    
                        </div>
                        <CRow class="mt-5 justify-content-center m-0">
                            <CCol cols="auto" class="text-center">
                                <CButton class="bg-1796FD custom-padding text-white" style="border-radius: 50px" @click="SubmitCart()" size="lg">
                                    Continue
                                </CButton>
                            </CCol>
                        </CRow>
                    </CCard>
    
                </div>
            </div>
            <Footer />
    
            <!-- Success Popup -->
            <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <div class="text-right">
                        <label @click="closeSuccess()" class="text-white">X</label>
                    </div>
                    <div class="text-center">
                        <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Pembelian berjaya tanpa bayaran. Terima kasih!
                        </h3>
                    </div>
                </div>
            </div>

            <div v-if="isPopupStudent" class="popup-all backdrop-all">
                <div class="popup-all2 bg-0A1129">
                    <div class="text-right">
                        <label @click="closeStudent()" class="text-white">X</label>
                    </div>
                    <div class="text-center">
                      <!-- Title -->
                        <div class="text-center mb-6">
                          <h2 class="text-2xl font-semibold">Select Student</h2>
                          <p class="text-sm text-gray-400">Please select only 1 student you want to buy this package for.</p>
                        </div>

                        <!-- Search bar -->
                        <div class="mb-4">
                          <input
                            type="text"
                            v-model="searchQuery"
                            placeholder="Search student..."
                            class="w-full px-4 py-2 rounded-lg bg-[#1E2640] text-white border-none focus:outline-none"
                            style="border-radius: 20px;
border: 1px solid rgba(224, 224, 224, 0.30);
background: rgba(255, 255, 255, 0.10);"
                          />
                        </div>

                        <div class="row">
                          <div
                            class="col-12 col-md-6 mb-4"
                            v-for="student in paginatedStudents"
                            :key="student.id"
                            @click="selectedStudent = student.id"
                          >
                            <div class="d-flex align-items-center p-3 bg-dark text-white rounded">
                              <!-- Avatar -->
                              <div class="flex-shrink-0">
                                <img
                                  :src="student.avatar"
                                  alt="Avatar"
                                  class="rounded-circle"
                                  style="width: 60px; height: 60px; object-fit: cover;"
                                />
                              </div>

                              <!-- Name & Class -->
                              <div class="flex-grow-1 mx-3 text-left">
                                <p class="mb-1 font-weight-bold">{{ student.name }}</p>
                                <p class="mb-0 small text-muted">
                                   {{ student.level }} •  {{ student.class }}
                                </p>
                              </div>

                              <!-- Radio Button -->
                              <div>
                                <input
                                  type="radio"
                                  name="student"
                                  :value="student.id"
                                  v-model="selectedStudent"
                                  class="form-check-input"
                                />
                              </div>
                            </div>
                          </div>
                          </div>
                        <!-- Pagination -->
                        <div class="text-center mb-4">
                          <button
                            v-for="page in totalPages"
                            :key="page"
                            @click="currentPage = page"
                            class="mx-1 px-3 py-1 rounded bg-[#1E2640] hover:bg-blue"
                            :class="{'bg-1796FD text-white': currentPage === page}"
                          >
                            {{ page }}
                          </button>
                        </div>

                        <!-- Continue Button -->
                        <div class="text-center">
                          <button
                            class="bg-1796FD hover:bg-1796FD text-white font-semibold py-3 px-6 rounded-lg w-full"
                            @click="continuePurchase"
                          >
                            Teruskan Pembelian Pakej
                          </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "@/containers/AllHeader.vue";
import Footer from "@/components/Footer.vue";
export default {

    name: "ShoppingCart",
    data() {
        return {
            cartItems: [],
            selectedItems: [],
            user: {},
            FullName: '',
            email: '',
            phone: '',
            isPopupSuccess: false,
            isPopupStudent:true,
            students: [],           // ✅ Initialize properly
            selectedStudent: null,
            searchQuery: '',
            currentPage: 1,
            itemsPerPage: 4,
            isPopupStudent: false,
            selectedStudentsMap: {},
            currentItemForStudent: null
        };
    },
    components: {
        Mainlayout,
        Footer,

    },
    computed: {
        selectedTotal() {
            return this.flattenedCartItems.reduce((sum, item) => {
                if (this.selectedItems.includes(item.SubjectUID) && item.Status) {
                    const qty = item.Quantity || 1;
                    return sum + (item.Price - item.Discount) * qty;
                }
                return sum;
            }, 0);
        },
        flattenedCartItems() {
            const result = [];
            this.cartItems.forEach(item => {
                if (item.Subjects && item.Subjects.length > 0) {
                    item.Subjects.forEach(subject => {
                        result.push({
                            ...subject,
                            ProductClassId: subject.ProductClassId || subject.SubjectDetails ?.ProductClassId, // ✅ fallback
                            ParentProductId: item.ParentProductId || item.ID,
                            TuitionPackageId: item.TuitionPackageId,
                            ParentTitle: item.Title,
                            PicturePath: item.PicturePath,
                            Status: item.Status,
                            Price: subject.Price,
                            Discount: subject.Discount,
                            Quantity: subject.Quantity,
                            SubjectDetails: subject.SubjectDetails || {
                                Date: subject.Date,
                                Time: subject.Time,
                                CourseName: subject.SubjectName,
                                ProductClassId: subject.ProductClassId || subject.ProductClassId, // fallback
                                TuitionPackageId: item.TuitionPackageId,
                            }
                        });
                    });
                } else {
                    result.push(item);
                }
            });
            return result;
        },
        groupedFlattenedCart() {
            const groups = {};
            this.flattenedCartItems.forEach(item => {
                const group = item.ParentTitle || item.Title;
                if (!groups[group]) groups[group] = [];
                groups[group].push(item);
            });
            return groups;
        },
        filteredStudents() {
          if (!this.searchQuery) return this.students;
          return this.students.filter(s =>
            s.name.toLowerCase().includes(this.searchQuery.toLowerCase())
          );
        },
        paginatedStudents() {
          const start = (this.currentPage - 1) * this.itemsPerPage;
          return this.filteredStudents.slice(start, start + this.itemsPerPage);
        },
        totalPages() {
          return Math.ceil(this.filteredStudents.length / this.itemsPerPage);
        }
    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                try {
                    const items = JSON.parse(localStorage.getItem("cartItems"));
                    this.cartItems = Array.isArray(items) ?
                        items.map(item => {
                            if (Array.isArray(item.Subjects)) {
                                item.Subjects = item.Subjects.map(subject => ({
                                    ...subject,
                                    ProductClassId: subject.ProductClassId || subject.SubjectDetails ?.ProductClassId || null
                                }));
                            }
                            return {
                                ...item,
                                Quantity: item.Quantity || 1,
                                Status: item.Status === true || item.Status === 'true',
                                TuitionPackageId: item.hasOwnProperty('TuitionPackageId') ? item.TuitionPackageId : null
                            };
                        }) :
                        [];
                } catch (e) {
                    console.warn("Failed to parse cartItems from localStorage:", e);
                    this.cartItems = [];
                }

                // ✅ Call this to auto-select available items
                this.loadCartItems();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
        }
    },
    methods: {
        removeItem(subjectUID) {
            const cart = JSON.parse(localStorage.getItem("cartItems")) || [];

            const updatedCart = cart
                .map(item => {
                    if (Array.isArray(item.Subjects)) {
                        const filteredSubjects = item.Subjects.filter(sub => sub.SubjectUID !== subjectUID);
                        if (filteredSubjects.length === 0) return null;
                        return { ...item, Subjects: filteredSubjects };
                    }
                    return item;
                })
                .filter(Boolean);

            // Save updated cart and reflect changes in both localStorage and state
            localStorage.setItem("cartItems", JSON.stringify(updatedCart));
            this.cartItems = updatedCart; // ✅ this line is crucial
            this.loadCartItems(); // ✅ update selectedItems based on new cartItems
        },
        loadCartItems() {
            this.selectedItems = this.flattenedCartItems
                .filter(item => item.Status)
                .map(item => item.SubjectUID);
        },
        increaseQty(item) {
            if (!item.Status) return;

            const found = this.findCartItemAndSubject(item);
            if (found) {
                found.subject.Quantity = (found.subject.Quantity || 1) + 1;
                this.saveCartChanges();
            }
        },

        decreaseQty(item) {
            if (!item.Status) return;

            const found = this.findCartItemAndSubject(item);
            if (found && found.subject.Quantity > 1) {
                found.subject.Quantity--;
                this.saveCartChanges();
            }
        },

        findCartItemAndSubject(item) {
            // Find the parent cart item and the subject in it
            const cartItem = this.cartItems.find(ci =>
                Array.isArray(ci.Subjects) && ci.Subjects.some(s => s.SubjectUID === item.SubjectUID)
            );

            const subject = cartItem ?.Subjects.find(s => s.SubjectUID === item.SubjectUID);

            if (cartItem && subject) {
                return { cartItem, subject };
            }
            return null;
        },

        saveCartChanges() {
            localStorage.setItem("cartItems", JSON.stringify(this.cartItems));
            this.loadCartItems(); // Refresh display
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.GetListChild(this.user.id);
                    this.FullName = this.user.name || '';
                    this.email = this.user.email || '';
                    this.phone = this.user.phone || '';
                } else {
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },
        async GetListChild(id) {
          try {
            const response = await this.$API.get(this.$GetParentByUserId + "?id=" + id, {
              withCredentials: true
            });

            if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
              const studentDetails = response.data[0].studentDetails.filter(student => student.status === "active") || [];

              this.students = studentDetails.map(student => ({
                id: student.id,
                name: student.name,
                level: student.grade,
                class: student.className,
                avatar: student.profileImagePath
              }));

              console.log("Loaded students:", this.students);
            } else {
              console.error("Failed to get student list or no data returned");
            }
           
          } catch (error) {
            console.error("API error:", error);
          }
        },
        GoToLogin() {
            this.$router.push({
                path: '/login',
                query: {
                    targetUrl: this.$route.fullPath // capture current page as return path
                }
            });
        },

        SubmitCart() {
            const selectedSubjects = this.flattenedCartItems
                .filter(item => this.selectedItems.includes(item.SubjectUID) && item.Status);

            const groupedByParent = _.groupBy(selectedSubjects, subject => {
                const parentId = subject.ParentProductId || subject.SubjectDetails ?.ParentProductId;

                // Consider it 'loose' if no parent or the parent package is not in cartItems
                const hasParent = parentId && this.cartItems.some(c =>
                    `${c.ID}` === `${parentId}` || `${c.ParentProductId}` === `${parentId}`
                );

                return hasParent ? parentId : 'loose';
            });
            const hasStudent = selectedSubjects.some(sub => {
                const stu = this.selectedStudentsMap[sub.SubjectUID];
                return stu && stu.id;
            });

            if (!hasStudent) {
                alert("Sila pilih pelajar untuk setiap pembelian pakej. Jika tiada list pelajar,anda perlu menambah anak anda ke akaun ini terlebih dahulu.");
                window.open("https://app.flyhigh.my/#/RegisterStudent");
                return;
            }

            const selectedPackages = Object.entries(groupedByParent).map(([productIdStr, subjects]) => {
                const isLooseItem = productIdStr === 'loose';
                const productId = isLooseItem ? null : parseInt(productIdStr);

                const parentItem = this.cartItems.find(c =>
                    `${c.ParentProductId}` === `${productId}` || `${c.ID}` === `${productId}`
                );
                const selectedStudent = subjects
                                        .map(sub => this.selectedStudentsMap[sub.SubjectUID])
                                        .find(stu => stu && stu.id);


                return {
                    PackageId: isLooseItem ? null : productId,
                    TuitionPackageId: parentItem.TuitionPackageId,
                    ManualStudentId: selectedStudent ? selectedStudent.id : 0,
                    Price: parentItem ?.Price ?? 0,
                    Discount: parentItem ?.Discount ?? 0,
                    Quantity: parentItem ?.Quantity ?? 1,
                    Amount: subjects.reduce((sum, s) => sum + ((s.Price || 0) - (s.Discount || 0)), 0),
                    IsLooseItem: subjects.every(s => !s.ProductClassId && !s.SubjectDetails ?.ProductClassId) ?
                        false : true,
                    Subjects: subjects.every(s => !s.ProductClassId && !s.SubjectDetails ?.ProductClassId) ?
                        [] :
                        subjects.map(subject => ({
                            ProductClassId: subject.ProductClassId || subject.SubjectDetails ?.ProductClassId,
                            Price: subject.Price,
                            Discount: subject.Discount,
                            Quantity: 1,
                            Amount: (subject.Price || 0) - (subject.Discount || 0),
                        }))
                };
            });

            const totalAmount = selectedPackages.reduce((sum, item) => sum + (item.Amount || 0), 0);

            const payload = {
                userId: this.user.id,
                phone: this.user.phone,
                amount: totalAmount,
                packages: selectedPackages
            };

            this.$API
                .post(this.$SubscribePackage, payload)
                .then(response => {
                      const billId = response.data; // <-- this was missing

                      if (
                        typeof billId === 'string' &&
                        billId.toLowerCase().includes("no package found")
                      ) {
                        this.isPopupSuccess = true;
                        this.Message = "No package found. You are only subscribing to free items.";
                        return;
                      }

                      // Proceed to Billplz if billId is valid
                      window.open(`https://www.billplz.com/bills/${billId}`, "_self");
                    })
                .catch(error => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error ?.response ?.data ?.message || "Unknown error";
                });
        },
        closeSuccess() {
            this.isPopupSuccess = false;

        },
        SignOut: function() {
            return this.$API
                .get(this.$SignOut, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.$router.push("/Login");
                    }
                });
        },
        closeStudent() {
            this.isPopupStudent = false;
          },
          continuePurchase() {
  if (!this.selectedStudent) {
    alert("Please select a student.");
    return;
  }

  const student = this.students.find(s => s.id === this.selectedStudent);
  if (student && this.currentItemForStudent) {
    this.selectedStudentsMap[this.currentItemForStudent.SubjectUID] = student;
  }

  this.closeStudent();
},
          OpenStudent(item) {
    this.currentItemForStudent = item; // Track which item is being assigned
    this.selectedStudent = this.selectedStudentsMap[item.SubjectUID]?.id || null;
    this.isPopupStudent = true;
  },
          
    }
};
</script>